import React, { PureComponent } from 'react'

import { FeesPage } from '../../../components/MfeParcels/FeesPage'

import ContainerWithTitle from '../../HOC/ContainerWithTitle'

class FeeOptionsContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <FeesPage
        handleError={(error) => {
          console.log(error)
        }}
      />
    )
  }
}

const FeeOptionsWithTitle = ContainerWithTitle(FeeOptionsContainer, 'Fees (New)')

export default FeeOptionsWithTitle



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/FeeOptions.js